export default {
  testokey: {
    test2: 'test2 value en',
  },
};
